import { useSubscribers } from "../../../../store/subscription/useSubscribers";

import { SubscriberController } from "../../../../services/controllers/subscription";

import { Alert } from "../../../../components/ui/Alert";

export function AlertPauseSubscription() {
  const details = useSubscribers(st => st.data.details)

  const CSubscriber = SubscriberController();

  if (!details) return null

  return (
    <Alert.Root name={CSubscriber.pauseSubscriptionAlertName}>
      <Alert.Content>
        <Alert.Title>Pausar Assinatura</Alert.Title>
        <ul className="space-y-3 mb-10">
          <li>Cliente irá receber por Email um link para <strong className="highlight">PAUSAR A ASSINATURA</strong>;</li>
          <li>Quando entrar nesse link, o cliente deverá confirmar a solicitação de pausa;</li>
          <li>A pausa tem uma duração de 15 dias corridos.</li>
          <li>A assinatura permanecerá <strong className="highlight">PAUSADA</strong> até o fim do período de pausa;</li>
          <li>O link expira em até 24 horas;</li>
          <li><strong className="highlight">📱 A pausa também pode ser feita pelo APP.</strong></li>
        </ul>
        <Alert.Actions>
          <Alert.Cancel>Cancelar</Alert.Cancel>
          <Alert.Confirm
            onClick={() => CSubscriber.pauseSubscribers(false, true)}
          >
            Enviar
          </Alert.Confirm>
        </Alert.Actions>
      </Alert.Content>
    </Alert.Root>
  )
}
